import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholiresort() {



    const cardData =
    {
        keyword: 'Morachi Chincholi Resort Pune',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi Resort Pune',
        headingDescription: 'Escape to the tranquil beauty of Anand Krushi Paryatan Kendra, a premier Morachi Chincholi resort Pune located just 55 km from the city. Set on a sprawling 40-acre agri-tourism farm, this eco-friendly resort offers the perfect combination of rural charm and modern comfort for families, groups, and solo travelers alike. Guests can enjoy a variety of activities including bullock cart and tractor rides, horse riding, boating, swimming, rain dance, and traditional village games. The resort also features engaging puppet shows and magic performances that add a cultural touch to your stay.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Rustic Farmstay Cottages",
    "description": "Stay in cozy, traditional cottages built with natural materials like mud, bamboo, and wood. Enjoy modern comforts with attached bathrooms, comfortable beds, and peaceful views of farmland and mango orchards."
  },
  {
    "title": "Swimming Pool & Splash Zone",
    "description": "Relax and refresh in resort swimming pools or splash zones designed for kids and adults alike. Perfect for cooling off after a day of exploring or farm activities."
  },
  {
    "title": "Organic Farm & Garden Tours",
    "description": "Take guided walks through organic vegetable patches, flower gardens, and fruit orchards. Learn about sustainable farming practices and pick fresh produce yourself."
  },
  {
    "title": "Traditional Maharashtrian Cuisine",
    "description": "Enjoy meals prepared with fresh, local ingredients—featuring specialties like bhakri, pithla, varan-bhat, and puranpoli. Meals are served in open-air dining areas with rustic decor."
  },
  {
    "title": "Outdoor Activity Zones",
    "description": "Engage in activities such as bullock cart rides, tractor safaris, rural games (lagori, kho-kho), rope courses, and swings. Fun for families, couples, and groups."
  },
  {
    "title": "Evening Bonfire & Folk Music",
    "description": "Unwind around a bonfire with live folk music performances, dholki beats, and storytelling. Ideal for a relaxed, culturally immersive evening."
  },
  {
    "title": "Rain Dance & Party Area",
    "description": "Some resorts offer rain dance parties with DJ music and splash pools—perfect for celebrations, birthdays, or weekend getaways."
  },
  {
    "title": "Kids Play Area & Animal Interaction",
    "description": "Dedicated kids zones with slides, swings, and animal petting corners featuring goats, cows, and calves, making it a hit for families with young children."
  },
  {
    "title": "Conference & Event Facilities",
    "description": "Several resorts provide halls and open spaces for corporate events, weddings, and large gatherings, with catering and decoration services."
  },
  {
    "title": "Comfortable Transportation Access",
    "description": "Located just about 55 km from Pune city, resorts are easily accessible via private vehicles or hired transport, making for a hassle-free weekend or day trip."
  }
],




  "services": [
    {
      "name": "Family‑Friendly Resorts in Morachi Chincholi",
      "description": "Resorts designed for families, offering safe play zones, open lawns, pet farms, and fun group activities—perfect for spending quality time with loved ones in a relaxed countryside atmosphere."
    },
    {
      "name": "Nature Resorts Near Pune",
      "description": "Eco‑friendly resorts nestled in lush green surroundings, where guests can enjoy nature trails, bird‑watching, and peaceful stays just a short drive from Pune."
    },
    {
      "name": "Budget Resorts at Morachi Chincholi",
      "description": "Affordable countryside resorts offering comfortable rooms, simple amenities, farm tours, and wholesome meals—ideal for budget‑conscious travelers and families."
    },
    {
      "name": "Agro‑Tourism Resorts for Weekend Stays",
      "description": "Resorts that combine comfortable stays with immersive agro‑experiences—farm visits, seasonal fruit tasting, cow‑feeding, and organic farming workshops for a meaningful weekend escape."
    },
    {
      "name": "Resorts with Outdoor Activities",
      "description": "Resorts equipped with adventure parks, rope‑courses, farm games, bullock cart rides, and group competitions—great for both fun and fitness amid fresh air."
    },
    {
      "name": "Poolside Resorts Near Pune",
      "description": "Resorts featuring clean swimming pools with scenic farm views—perfect for families and couples looking to cool off during summer weekends."
    },
    {
      "name": "Resorts with Traditional Maharashtrian Food",
      "description": "Authentic rural dining experiences serving homemade meals like zunka‑bhakri, puran‑poli, aamras, and seasonal local produce cooked fresh in traditional style."
    },
    {
      "name": "Kid‑Friendly Resorts",
      "description": "Resorts designed with children in mind—safe play areas, animal interactions, story‑telling sessions, craft workshops, and supervised pool zones for worry‑free fun."
    },
    {
      "name": "Event Hosting Resorts Near Pune",
      "description": "Resorts with well‑managed event spaces—lawns, banquet halls, audio setup—perfect for birthdays, sunset gatherings, small weddings, or family occasions near Pune."
    },
    {
      "name": "Resorts with Bird Watching Tours",
      "description": "Stay at resorts near peacock zones and bird habitats, offering guided early‑morning bird watching walks and photography sessions amid natural landscapes."
    },
    {
      "name": "Day Stay Resorts in Morachi Chincholi",
      "description": "For short getaways, these resorts offer included day‑stay options with lunch, farm activities, play areas, and comfortable lounging for a perfect daytime retreat."
    },
    {
      "name": "Eco‑Resorts with Farm Experience",
      "description": "Resorts built with sustainable practices—mud huts, rainwater harvesting, composting—offering immersive farm stays with wildlife, gardening, and eco‑educational sessions."
    },
    {
      "name": "Weekend Resorts for Couples",
      "description": "Romantic weekend escapes featuring private cottages, candle‑lit dinners, nature walks, hammock zones, and peaceful ambiance far from city noise."
    },
    {
      "name": "Nature Retreat Resorts",
      "description": "Quiet resorts focused on wellness and nature—yoga decks, forest walks, meditation corners, and pond‑side seating in green, tranquil settings."
    },
    {
      "name": "Group Booking Resorts Near Pune",
      "description": "Resorts offering group‑friendly packages, catering to reunions, corporate fun days, or college outings with group meals, multiple activity zones, and event coordination."
    }
  ],
  "tableData": [
    ["Family‑Friendly Resorts in Morachi Chincholi", "Nature Resorts Near Pune"],
    ["Budget Resorts at Morachi Chincholi", "Agro‑Tourism Resorts for Weekend Stays"],
    ["Resorts with Outdoor Activities", "Poolside Resorts Near Pune"],
    ["Resorts with Traditional Maharashtrian Food", "Kid‑Friendly Resorts"],
    ["Event Hosting Resorts Near Pune", "Resorts with Bird Watching Tours"],
    ["Day Stay Resorts in Morachi Chincholi", "Eco‑Resorts with Farm Experience"],
    ["Weekend Resorts for Couples", "Nature Retreat Resorts"],
    ["Group Booking Resorts Near Pune", ""]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Authentic Rural Experience",
    "WhyChoosedescription": "Morachi Chincholi resorts offer a genuine agro-tourism experience, allowing visitors to immerse themselves in rural life with activities like bullock cart rides, tractor tours, and bird watching amidst the presence of over 2,500 peacocks."
  },
  {
    "WhyChooseheading": "Diverse Outdoor Activities",
    "WhyChoosedescription": "Guests can enjoy a variety of outdoor activities including zip-lining, rain dance, swimming pool access, and traditional rural games such as Viti Dandu and Lagori, ensuring a fun-filled camping experience."
  },
  {
    "WhyChooseheading": "Comfortable Accommodation Options",
    "WhyChoosedescription": "The resorts provide various stay options, including cottages and dormitories, equipped with modern amenities. Packages include meals, activities, and access to facilities like a children's park and hammock relaxation zones."
  },
  {
    "WhyChooseheading": "Cultural and Culinary Delights",
    "WhyChoosedescription": "Experience authentic Maharashtrian cuisine with dishes like Puran Poli, Maswadi, and Sorghum bread. Evening bonfires accompanied by music and dance add to the cultural richness of the camping experience."
  },
  {
    "WhyChooseheading": "Eco-Friendly and Peaceful Environment",
    "WhyChoosedescription": "Situated in a pollution-free zone, the resorts promote well-being and a healthy lifestyle, offering a serene environment free from noise and pollution, perfect for relaxation and rejuvenation."
  },
  {
    "WhyChooseheading": "Convenient Location Near Pune",
    "WhyChoosedescription": "Located approximately 55 km from Pune, Morachi Chincholi resorts are easily accessible, making them an ideal destination for a quick getaway to experience nature and rural life."
  }
]




























    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Are there good resorts in Morachi Chincholi near Pune?',
    answer: 'Yes, Morachi Chincholi offers several well-maintained resorts near Pune that cater to families, groups, and event organizers looking for a rural getaway.',
  },
  {
    id: 'FAQ2',
    question: 'What facilities do resorts in Morachi Chincholi offer?',
    answer: 'Facilities typically include swimming pools, rain dance setups, bullock cart rides, children’s play areas, spacious lawns, and traditional Maharashtrian meals.',
  },
  {
    id: 'FAQ3',
    question: 'Can I book a resort for a weekend stay?',
    answer: 'Yes, most resorts offer both day packages and overnight stay options with meals and activities included.',
  },
  {
    id: 'FAQ4',
    question: 'Is Morachi Chincholi easily accessible from Pune?',
    answer: 'Yes, it is approximately 60–65 km from Pune and can be reached within 1.5 to 2 hours by road.',
  },
  {
    id: 'FAQ5',
    question: 'Do resorts in Morachi Chincholi offer event hosting services?',
    answer: 'Yes, many resorts are equipped to host birthdays, weddings, corporate outings, and school or college picnics.',
  },
  {
    id: 'FAQ6',
    question: 'Are meals included in resort packages?',
    answer: 'Most resorts offer packages that include breakfast, lunch, high tea, and sometimes dinner, usually featuring authentic Maharashtrian food.',
  },
  {
    id: 'FAQ7',
    question: 'Is advance booking required for Morachi Chincholi resorts?',
    answer: 'Yes, especially on weekends and during peak seasons. Advance booking ensures availability and preferred package options.',
  },
  {
    id: 'FAQ8',
    question: 'Are the resorts suitable for kids and elderly guests?',
    answer: 'Absolutely. The resorts are designed to be family-friendly with flat terrains, shaded areas, and easy access for all age groups.',
  },
  {
    id: 'FAQ9',
    question: 'Do resorts have eco-friendly or nature-based experiences?',
    answer: 'Yes, many resorts emphasize agro-tourism and offer eco-friendly experiences like farm tours, organic meals, and birdwatching.',
  },
  {
    id: 'FAQ10',
    question: 'What is the best time to visit resorts in Morachi Chincholi?',
    answer: 'October to March is ideal due to the pleasant weather and increased peacock sightings in the natural surroundings.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashwin Jadhav, Pune',
    feedback: "Stayed at a resort in Morachi Chincholi last weekend. Clean rooms, great food, and peaceful vibes. Highly recommended for quick getaways!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Mitali Deshmukh, Hadapsar',
    feedback: "Perfect place to relax with family. The resort offered excellent hospitality and plenty of outdoor activities. Will visit again soon!",
    rating: 5,
  },
];































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Morachi Chincholi Resort Pune",
  "image": "https://morachichincholi.in/assets/images/morachi-chincholi-resort.jpg",
  "description": "Family-friendly and budget resorts in Morachi Chincholi near Pune offering agro-tourism weekend stays, outdoor activities, poolside fun, traditional Maharashtrian cuisine, bird watching tours, eco-resorts, and event hosting facilities.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1024"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5200",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/morachi-chincholi-resort"
  }
};



    return (
        <div>
<Helmet>
  <title>Morachi Chincholi Resort Pune | Family-Friendly Agro-Tourism Stays</title>
  <meta 
    name="description" 
    content="Stay at family-friendly and budget resorts in Morachi Chincholi near Pune. Enjoy agro-tourism weekend stays, outdoor activities, poolside resorts, traditional Maharashtrian food, bird watching, eco-resorts, and event hosting." 
  />
  <meta 
    name="keywords" 
    content="Family-friendly resorts in Morachi Chincholi, Nature resorts near Pune, Budget resorts at Morachi Chincholi, Agro-tourism resorts for weekend stays, Resorts with outdoor activities, Poolside resorts near Pune, Resorts with traditional Maharashtrian food, Kid-friendly resorts, Event hosting resorts near Pune, Resorts with bird watching tours, Day stay resorts in Morachi Chincholi, Eco-resorts with farm experience, Weekend resorts for couples, Nature retreat resorts, Group booking resorts near Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/35.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholiresort;